import { cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react';

export function AudioDiff(props) {
    const { incomingMedia, updatedMedia, onUpdateData, onRestoreData } = props;

    const isUpdated = updatedMedia.src === incomingMedia.src;

    if (!incomingMedia?.src) return null;

    return (
        <div>
            <p className="pt-4 pb-2 w-full font-semibold text-left">{_t.edit.fields['jingle']()}</p>
            <div
                className={cn(
                    'rounded overflow-hidden aspect-video border border-neutral-500 flex items-center justify-center',
                    isUpdated && 'border-4 border-primary-500'
                )}
            >
                <div className="w-full h-full flex justify-center items-center">
                    <audio controls>
                        <source src={incomingMedia.src} type="audio/mp3" />
                    </audio>
                    <Icon
                        icon={isUpdated ? 'fa6-solid:xmark' : 'el:ok'}
                        width="1.8rem"
                        height="1.8rem"
                        className={cn(
                            'rounded-lg border-2 border-neutral-100 bg-neutral-50 hover:bg-neutral-200 p-2 transition-all cursor-pointer',
                            isUpdated ? 'text-red-500 hover:text-red-500' : 'text-primary-500 hover:text-primary-500'
                        )}
                        onClick={() => {
                            isUpdated ? onRestoreData() : onUpdateData();
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
